import { Card, CardHeader } from "reactstrap";
import styled from "styled-components";

const MetsecCard = styled(Card)`
  border-radius: 0 !important;
  > .card-header {
    padding: 0.5rem 0.75rem;
    font-weight: 500;
  }
`;

const MetsecCardHeader = styled(CardHeader)`
  border-radius: 0 !important;
  color: #fff !important;
  background-color: #0082b4 !important;
`;

export { MetsecCard, MetsecCardHeader };
